import {URL_BASE} from "../../../../../Globals.ts";
import {getIdToken} from "../../../../misc/miscUtils.ts";

export const getFilesToUpdate = async (user: any, projectName: string, files: string[]) => {
    if (!user) return;

    const token = await getIdToken(user);

    try {
        const url = `${URL_BASE}/api/getFilesToUpdate`;

        const response = await fetch(url, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Authorization": `Bearer ${token}`
            },
            body: JSON.stringify({ projectName, files })
        });

        if (response.ok) {
            const responseData = await response.json();
            const { filesToProcess } = responseData;

            return filesToProcess
        } else {
            console.error(`Error getting files to update: ${response.statusText}`);
        }
    } catch (error) {
        console.error(`Error getting files to update: ${error}`);
    }

    return []
};
